import { render, staticRenderFns } from "./SoftwareVersionTable.vue?vue&type=template&id=05fac002&scoped=true&"
import script from "./SoftwareVersionTable.vue?vue&type=script&lang=js&"
export * from "./SoftwareVersionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fac002",
  null
  
)

export default component.exports